import * as constant from "../constants/AdminConstant"

const initialState = {
    teacher: null,
    session: null,
    learner:null
   };
   
   export const AdminReducer = (state = initialState, action) => {
     switch (action.type) {
      case constant.FETCH_ALL_TEACHER:
        return {
             ...state,
            teacher: action.payload.teachers
        };
      case constant.GET_ALL_SESSION:
        //console.log(action.payload)
        return {
          ...state,
          session: action.payload.teacherData
        };
      case constant.FETCH_ALL_LEARNER:
        return {
          ...state,
          learner: action.payload.learner
        };
      case constant.FILTER_UPCOMING_PAST:
        console.log(action.payload)
        return {
          ...state,
          session: action.payload.sessions
        };
         //default
       default:
         return state;
     }
   }